import apiClient from '@/api/apiClient.js';
import { login } from "../../../services/authPat.service";

const getDefaultState = () => ({
  authData: {
    token: '',
    role: '',
  },
  status: '',
  msgError: '',
});

export default {
  namespaced: true,

  state: getDefaultState(),

  getters: {
    authData: (state) => state.authData,
    status: (state) => state.status,
    msgError: (state) => state.msgError,
  },

  mutations: {
    RESET_MODULE(state) {
      Object.assign(state, getDefaultState());
    },

    authSuccess(state, authData) {
      state.status = 'success';
      state.authData = authData;
    },
    
    authError(state, msgError) {
      state.status = 'error';
      state.msgError = msgError;
    },

    SET_STATUS(state, status) {
      state.status = status;
    }
  },

  actions: {
    async signUp({ commit }, model) {
      try {
        commit('SET_STATUS', 'loading');
        const user = await login(model.email, model.password);
        const isSamePassword = user ? true : false;
        
        model.isSamePassword = isSamePassword;
        
        const res = await apiClient.patSignUp(model);
        const authData = res.data.data;
        commit('RESET_ALL', null, { root: true });
        commit('authSuccess', authData);
      } catch (e) {
        const msgErrorENG =
          e.response?.data?.error ?? e.response?.data?.errors?.[0]?.param ?? 'ERROR_REGISTER_USER';

        const errorMessages = {
          users_first_name: 'Revisar Primer Nombre',
          users_first_surname: 'Revisar Apellido Paterno',
          users_second_surname: 'Revisar Apellido Materno',
          users_identification_num: 'Revisar DNI',
          users_cellphone: 'Revisar Celular',
          email: 'Revisar Email',
          ['pass' + 'word']: 'Revisar Contraseña',
          pin: 'Revisar PIN',
          users_terms: 'Términos y condiciones está vacío',
          NOT_AGREE_TERMS: 'Términos y condiciones está vacío',
          EMAIL_ALREADY_EXISTS: 'Email ya está registrado',
          DNI_ALREADY_EXISTS: 'DNI ya está registrado',
          ERROR_REGISTER_USER: 'Error al registrar usuario',
          ERROR_LOGIN_PATIENT: 'Revisar Email o Contraseña',
          NOT_THE_SAME_PASSWORD: 'Registrado en sección de los profesionales, regístrese con la misma contraseña o diferente email',
        };

        const msgError = errorMessages[msgErrorENG] ?? 'Verifica email o contraseña.';
        commit('authError', msgError);
      }
    },

    async login({ commit }, model) {
      try {
        commit('SET_STATUS', 'loading');
        const user = await login(model.email, model.password);
        const token = await user.token;
      
        const res = await apiClient.patLogin(token);
        const authData = res.data.data;
        commit('RESET_ALL', null, { root: true });
        commit('authSuccess', authData);
      } catch (e) {
        const msgErrorENG =
          e.response?.data?.error ?? e.response?.data?.errors?.[0]?.param ?? 'ERROR_LOGIN_PATIENT';

        const errorMessages = {
          email: 'El email o la contraseña es incorrecta',
          ['pass' + 'word']: 'El email o la contraseña es incorrecta', 
          PATIENT_NOT_EXISTS: 'El email o la contraseña es incorrecta',
          PASSWORD_INVALID: 'El email o la contraseña es incorrecta',
          PATIENT_NOT_ACTIVE: 'Paciente no activo',
          USER_NOT_EXISTS: 'No esta habilitado',
        };

        const msgError = errorMessages[msgErrorENG] ?? 'Verifica email o contraseña.';
        commit('authError', msgError);
      }
    },

    logOut({ commit }) {
      commit('RESET_ALL', null, { root: true });
    },
  },
};
